export default function ($translate) {
    return {
        KEYS: {
            CERTIFICATION: 'CERTIFICATION',
            CERTIFICATION_FEEDBACK: 'CERTIFICATION_FEEDBACK',
            SURVEY: 'SURVEY',
            FORM_360_FEEDBACK: 'FORM_360_FEEDBACK'
        },
        LABELS: {
            CERTIFICATION: $translate.instant('forms.Certification'),
            CERTIFICATION_FEEDBACK: $translate.instant('forms.Certification feedback'),
            SURVEY: $translate.instant('forms.Survey'),
            FORM_360_FEEDBACK: $translate.instant('forms.360 feedback')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/forms/type/index.js